import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

// datepicker

import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
// ckeditor

import { SwalError } from "../../../../utils/constants";

// utils

import {
  create,
  getAll,
  getById,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";
import {
  cleanUsers,
  uniqueUsers,
} from "../../../../utils/auxiliar/managePublications";

// middleware

import produce from "immer";
import Swal from "sweetalert2";
import Axios from "axios";

import { ROUTES } from "../../../../utils/routes";

import { useDelete } from "../../../../utils/hooks/useDelete";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

registerLocale("es", es);

export const ManagePublications = () => {
  let { staffId, isAdmin, token } = useSelector(({ user }) => user);

  const { PUBLICATIONS, INVESTIGATORS, investigatorPUBLICATION, groupPUBLICATION } = paths;
  const { id } = useParams();
  const history = useHistory();
  const { deleteIt } = useDelete();

  const [isCreate, setIsCreate] = useState(false);
  const [message, setMessage] = useState("");
  // userForm

  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [journal, setJournal] = useState("");
  const [publisher, setPublisher] = useState("");
  const [volume, setVolume] = useState("");
  const [number, setNumber] = useState("");
  const [pages, setPages] = useState("");
  const [authors, setAuthors] = useState("");
  const [summary, setSummary] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");
  const [isHidden, setIsHidden] = useState(false);
  const [subtitle, setSubtitle] = useState("");
  const [citation, setCitation] = useState("");
  const [citationDescription, setCitationDescription] = useState("");
  const [doi, setDoi] = useState("");
  const [location, setLocation] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const [participants, setParticipants] = useState([]);
  const [chosenParticipants, setChosenParticipants] = useState([]);

  const [staffAssociated, setStaffAssociated] = useState([]);
    const [investigationGroupsAssociated, setInvestigationGroupsAssociated] =
      useState([]);
  const [allowedEdit, setAllowedEdit] = useState(false);

  const isMounted = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMounted.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? loadDefaultData() : loadEditData();
    return () => {
      isMounted.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDefaultData = async () => {
    try {
      let investigators = await getAll(INVESTIGATORS, source);
      if (isMounted.current) {
        setIsCreate(true);
        setAllowedEdit(true);
        setTimeout(() => filterAdmins(investigators), 250);
        setTitle(title);
        setUrl(url);
        setJournal(journal);
        setPublisher(publisher);
        setVolume(volume);
        setNumber(number);
        setPages(pages);
        setAuthors(authors);
        setSummary(summary);
        setYear(year);
        setMonth(month);
        setDay(day);
        setSubtitle(subtitle);
        setCitation(citation);
        setCitationDescription(citationDescription);
        setDoi(doi);
        setLocation(location);
        setType(type);
        setStatus(status);
        setIsHidden(isHidden ? "1" : "0");
      }
    } catch (error) {
      console.log("HTTP call cancelado");
    }
  };

  const filterAdmins = (investigators) => {
    let newinvestigators = investigators.filter(
      (u) =>
        u.email !== "admin@admin.com" &&
        u.email !== "sombradoble@sombradoble.es"
    );
    setParticipants(newinvestigators);
  };

  const loadEditData = async () => {
    try {
      let response = await getById(PUBLICATIONS, id, source);
      isMounted.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelado");
    }
  };

  const buildObjToLoad = async (p) => {
    setStaffAssociated(p.staffAssociated);
    let investigators = await getAll(INVESTIGATORS, source);
    setTitle(p.title);
    setUrl(p.url);
    setJournal(p.journal);
    setPublisher(p.publisher);
    setVolume(p.volume);
    setNumber(p.number);
    setPages(p.pages);
    setAuthors(p.authors);
    setSummary(p.summary);
    setYear(p.year);
    setMonth(p.month);
    setDay(p.day);
    setInvestigationGroupsAssociated(p.investigationGroupsAssociated);
    setSubtitle(p.subtitle);
    setCitation(p.citation);
    setCitationDescription(p.citationDescription);
    setDoi(p.doi);
    setLocation(p.location);
    setType(p.type);
    setStatus(p.status);
    setIsHidden(p.isHidden ? "1" : "0");
    if (isMounted.current) {
      setParticipantsDisplay(p, investigators);
      setAllowedEdit(true);
    }
  };

  const setParticipantsDisplay = async ({ staffPublications }, allStaff) => {
    setChosenParticipants(staffPublications);
    // get unassigned investigators by comparing with participants
    let nonChosenStaff = uniqueUsers(allStaff, staffPublications);
    setParticipants(cleanUsers(nonChosenStaff));
  };

 

  // HANDLE INVESTIGATORS
  const addInvestigator = (ip) => {
    const parsedIp = JSON.parse(ip);
    const newParticipant = {
      staff: {
        id: parsedIp.id,
        nombre: parsedIp.nombre,
        apellidos: parsedIp.apellidos,
        investigationGroup: { id: parsedIp.investigationGroupId },
      },
    };

    // add chosenParticipant
    setChosenParticipants((state) =>
      produce(state, (draftState) => {
        draftState.push(newParticipant);
      })
    );

    // remove ip from list
    setParticipants((state) =>
      produce(state, (draftState) =>
        draftState.filter(({ id }) => id !== parsedIp.id)
      )
    );
  };

  const removeInvestigator = (participant) => {
    if (!allowedEdit) return;

    // Remove chosenParticipant
    setChosenParticipants((state) =>
      produce(state, (draftState) =>
        draftState.filter(({ staff }) => staff.id !== participant.staff.id)
      )
    );

    // Add participant back to list
    setParticipants((state) =>
      produce(state, (draftState) => {
        draftState.push(participant.staff);
      })
    );
  };

  const handleSubmit = () => {
    const publication = build(staffId);
    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} publicación?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(
      ({ isConfirmed }) => isConfirmed && handleConfirmation(publication)
    );
  };

  const handleConfirmation = (publication) => {
    let createOrUpdate = isCreate
      ? create(PUBLICATIONS, publication, source)
      : update(PUBLICATIONS, id, publication, source);
    createOrUpdate
      .then(async ({ id: publicationId }) => {
        //Armo array para staff-publication
        const staffPublications = chosenParticipants.map((participant) => ({
          staffId: participant.staff.id,
          publicationId: publicationId,
        }));
        // Le agregamos los selected desde BD
        const staffPublicationsWithSelected = staffPublications?.map(
          (chosenParticipants) => {
            const match = staffAssociated?.find(
              (staffFromDB) =>
                staffFromDB.staffId === chosenParticipants?.staffId
            );
            return {
              ...chosenParticipants,
              selected: match ? match.selected : false,
            };
          }
        );
        //Armo array para investigationGroup-publication
        const seenIds = new Set();
        const investigationGroupPublications = chosenParticipants
          .filter((participant) => participant.staff.investigationGroup?.id)
          .filter((participant) => {
            if (seenIds.has(participant.staff.investigationGroup.id)) {
              return false;
            } else {
              seenIds.add(participant.staff.investigationGroup.id);
              return true;
            }
          })
          .map((participant) => ({
            investigationGroupId: participant.staff.investigationGroup.id,
            publicationId: publicationId,
          }));

        // Le agregamos los selected desde BD
        const investigationGroupPublicationsWithSelected =
          investigationGroupPublications.map((choosenGroups) => {
            const match = investigationGroupsAssociated.find(
              (groupFromDB) =>
                groupFromDB.investigationGroupId ===
                choosenGroups.investigationGroupId
            );
            return {
              ...choosenGroups,
              selected: match ? match.selected : false,
            };
          });
 await create(
   `${groupPUBLICATION}/${publicationId}`,
   investigationGroupPublicationsWithSelected,
   source
 );
        await create(
          `${investigatorPUBLICATION}/${publicationId}`,
          staffPublicationsWithSelected,
          source
        );
        let createOrUpdateText = isCreate ? "creada" : "editada";
        Swal.fire({
          icon: "success",
          text: `Publicación ${createOrUpdateText} correctamente.`,
        });
        history.push(`${ROUTES.Publications.all}/${publicationId}`);
        isMounted.current && setIsCreate(false);
      })
      .catch(
        () => Swal.fire({ icon: "error", text: SwalError }),
        
      );
  };

  const build = (investigatorId) => {
    const publication = {
      staffId: investigatorId,
      chosenParticipants,
      title,
      url,
      journal,
      publisher,
      volume,
      number,
      pages,
      authors,
      summary,
      year,
      month,
      day,
      isHidden: isHidden === "1" ? true : false,
      subtitle,
      citation,
      citationDescription,
      doi,
      location,
      type,
      status,
    };
    return publication;
  };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Publicacion
        </button>
      );
    }
    //if is update && logged user included as IP
    return (
      <>
        <button className="baseBtn" onClick={handleSubmit}>
          Guardar cambios
        </button>
        <button
          className="smallBtn btn-danger ml-1"
          onClick={() =>
            deleteIt(PUBLICATIONS, id, ROUTES.Publications.all, source)
          }
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </>
    );
  };

  const excludePublication = async (e) => {
    Swal.fire({
      title: "Excluir",
      text: "Esta seguro que desea excluir esta publicación? Esta acción no puede deshacerse",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(async ({ isConfirmed }) => {
      if (isConfirmed) {
        try {
          update(
            PUBLICATIONS,
            e.target.value,
            { status: "excluded" },
            token,
            source
          ).then(() => {
            Swal.fire({
              text: "Se ha excluido la publicación",
              icon: "success",
            });
            history.push("/publicaciones");
          });
        } catch (error) {
          Swal.fire({
            icon: "error",
            text: SwalError,
          });
        }
      } else {
        Swal.fire({ text: "No se ha excluido la publicación", icon: "info" });
      }
    });
  };

  return (
    <div className="centerPage">
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col d-flex justify-content-between">
            <div className="mw-600">
              <h3>{title}</h3>
            </div>
            <div>{editDeleteButtons()}</div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>*Título</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título"
              value={title}
              onChange={({ target: { value } }) => {
                setTitle(value);
              }}
            />
          </div>
          <div className="col">
            <small>Enlace pubmed</small>
            <input
              type="text"
              className="form-control"
              placeholder="Url"
              value={url}
              onChange={({ target: { value } }) => {
                setUrl(value);
              }}
            />
          </div>
          <div className="col">
            <small>Journal</small>
            <input
              type="text"
              className="form-control"
              placeholder="Journal"
              value={journal}
              onChange={({ target: { value } }) => {
                setJournal(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Volumen</small>
            <input
              type="text"
              className="form-control"
              placeholder="Volumen"
              value={volume}
              onChange={({ target: { value } }) => {
                setVolume(value);
              }}
            />
          </div>
          <div className="col">
            <small>Número</small>
            <input
              type="text"
              className="form-control"
              placeholder="Número"
              value={number}
              onChange={({ target: { value } }) => {
                setNumber(value);
              }}
            />
          </div>
          <div className="col">
            <small>Página</small>
            <input
              type="text"
              className="form-control"
              placeholder="Página"
              value={pages}
              onChange={({ target: { value } }) => {
                setPages(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Autores</small>
            <input
              type="text"
              className="form-control"
              placeholder="Autores"
              value={authors}
              onChange={({ target: { value } }) => {
                setAuthors(value);
              }}
            />
          </div>
          <div className="col">
            <small>Editor</small>
            <input
              type="text"
              className="form-control"
              placeholder="Editor"
              value={publisher}
              onChange={({ target: { value } }) => {
                setPublisher(value);
              }}
            />
          </div>
          {/* <div className="col">
            <small>Resumen</small>
            <input
              type="text"
              className="form-control"
              placeholder="Resumen"
              value={summary}
              onChange={({ target: { value } }) => {
                setSummary(value);
              }}
            />
          </div> */}
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Año</small>
            <input
              type="text"
              className="form-control"
              placeholder="Año"
              value={year}
              onChange={({ target: { value } }) => {
                setYear(value);
              }}
            />
          </div>
          <div className="col">
            <small>Mes</small>
            <input
              type="text"
              className="form-control"
              placeholder="Mes "
              value={month}
              onChange={({ target: { value } }) => {
                setMonth(value);
              }}
            />
          </div>
          <div className="col">
            <small>Día</small>
            <input
              type="text"
              className="form-control"
              placeholder="Día"
              value={day}
              onChange={({ target: { value } }) => {
                setDay(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Es oculto?</small>
            <select
              className="form-control input"
              value={isHidden}
              onChange={({ target: { value } }) => {
                setIsHidden(value);
              }}
            >
              <option value="">Seleccione una opción</option>
              <option value={0}>No</option>
              <option value={1}>Si</option>
            </select>
          </div>
          {/* <div className="col">
            <small>Subtítulo</small>
            <input
              type="text"
              className="form-control"
              placeholder="Subtítulo"
              value={subtitle}
              onChange={({ target: { value } }) => {
                setSubtitle(value);
              }}
            />
          </div> */}
        </div>
        <div className="form-row mt-2">
          {/* <div className="col">
            <small>Citación</small>
            <input
              type="text"
              className="form-control"
              placeholder="Citación"
              value={citation}
              onChange={({ target: { value } }) => {
                setCitation(value);
              }}
            />
          </div> */}
          <div className="col">
            <small>Descripción de la citación</small>
            <input
              type="text"
              className="form-control"
              placeholder="Descripción"
              value={citationDescription}
              onChange={({ target: { value } }) => {
                setCitationDescription(value);
              }}
            />
          </div>
          <div className="col">
            <small>DOI</small>
            <input
              type="text"
              className="form-control"
              placeholder="DOI"
              value={doi}
              onChange={({ target: { value } }) => {
                setDoi(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          {/* <div className="col">
            <small>Ubicación</small>
            <input
              type="text"
              className="form-control"
              placeholder="Ubicación"
              value={location}
              onChange={({ target: { value } }) => {
                setLocation(value);
              }}
            />
          </div> */}

          <div className="col">
            <span>Tipo</span>
            <select
              className="form-control input"
              value={type}
              onChange={({ target: { value } }) => {
                setType(value);
              }}
            >
              <option value="">Seleccione una opción</option>
              <option value="journal-article">Artículo de revista</option>
              <option value="proceedings-article">
                Artículo de procedimiento
              </option>
              <option value="book-chapter">Capítulo de libro</option>
              <option value="other">Otros</option>
              <option value="reference-entry">Entrada de referencia</option>
              <option value="book">Libro</option>
              <option value="posted-content">Contenido publicado</option>
              <option value="edited-book">Libro editado</option>
              <option value="dataset">Conjunto de datos</option>
            </select>
          </div>
        </div>
        <div className="form-row mt-4">
          <div className="col">
            <small>Seleccione participantes</small>
            <select
              className="form-control input"
              value={""}
              onChange={({ target: { value } }) => addInvestigator(value)}
              disabled={!allowedEdit}
            >
              <option value={""}>Investigadores participantes</option>
              {participants?.map((i) => (
                <option key={i.id} value={JSON.stringify(i)}>
                  {`${i.apellidos} , ${i.nombre}`}
                </option>
              ))}
            </select>
            {chosenParticipants?.map((participant) => (
              <span
                key={participant?.staff?.id}
                style={{ cursor: "pointer" }}
                className="badge badge-info badge-blue-color mr-1 mt-3"
                onClick={() => removeInvestigator(participant)}
              >
                {`${participant?.staff?.nombre} ${participant?.staff?.apellidos} `}
                X
              </span>
            ))}
          </div>
        </div>
      </div>
      {/* <button
				value={id}
				onClick={excludePublication}
				className="redBtn"
			>
				Excluir publicación
			</button> */}
    </div>
  );
};
